import Box from 'components/Box';
import Text from 'components/Text';
import colorTheme from 'constants/color';
import SwitchCalendarType from '../components/SwitchCalendarType';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import reportActions from 'features/report/services/actions';
import { ReportType } from '../constants';
import AppointmentDatePicker from '../components/DatePicker';
import Button from 'components/Button';
import reportSelectors from 'features/report/services/selectors';
import storage from 'utils/sessionStorage';
import { useNavigate } from 'react-router-dom';
import ProductsTable from './ProductsTable';
import CategoriesChart from './CategoriesChart';
import { useAppDispatch } from 'store/hooks';
import moment from 'moment';

const ProductsReport = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const dataAppointment = reportSelectors.getParams()?.[ReportType.PRODUCTS];
  useEffect(() => {
    if (dataAppointment) return;
    dispatch(reportActions.setParams({
      [ReportType.PRODUCTS]: {
        startTime: moment().format('MM-DD-YYYY'),
        endTime: moment().format('MM-DD-YYYY')
      }
    }));
  }, []);

  const onPrintSummary = () => {
    navigate(`/store/${storage.shop_id.get()}/report/print/products-report-summary`);
  };
  const onPrint = () => {
    navigate(`/store/${storage.shop_id.get()}/report/print/products-report`);
  };
  return (
    <ServicesReportStyled>
      {/* header */}
      <HeaderBox>
        <Box>
          <Text className='title-page' variant="H5">PRODUCTS REPORTS</Text>
        </Box>
        <HeaderBox className={'v2'}>
          <SwitchCalendarType v2 actions={reportActions} selectors={reportSelectors} type={ReportType.PRODUCTS} />
          <AppointmentDatePicker v2 size='middle' actions={reportActions} selectors={reportSelectors} type={ReportType.PRODUCTS} />
          <Button width='auto' cardCashier ntype='SECONDARY' className='btn-print' icon="print" onClick={onPrint}>
            Preview
          </Button>
        </HeaderBox>
      </HeaderBox>
      <ContainerContent>
        <ProductsTable />
        <CategoriesChart v2 />
      </ContainerContent>
    </ServicesReportStyled>
  );
};

export default ProductsReport;
const ContainerContent = styled.div`
display: flex;
align-self: stretch;
gap: 16px;
background: #fff;
`;

const ServicesReportStyled = styled.div`
    padding: 1.5rem;
    direction: flex;
    flex-direction: column;
    gap: 16px;
    min-height: unset;
    display: flex;
    flex-direction: column;
`;

const HeaderBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;

    &.v2 {
        .btn-print {
            .CONTENT_2 {
                color: #1D2129;
                text-align: center;
                font-family: Poppins;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
        }
    }
`;
